import { useEffect, useState } from "react";

interface AnimatedDotsProps {
  text: string;
  interval?: number;
  maxDots?: number;
}

export default function AnimatedDots({
  text,
  interval = 500,
  maxDots = 3,
}: AnimatedDotsProps) {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const id = setInterval(() => {
      setDots((prev) => (prev.length < maxDots ? prev + "." : ""));
    }, interval);

    return () => clearInterval(id);
  }, [interval, maxDots]);

  return (
    <span>
      {text}
      {dots}
    </span>
  );
}
